import {noop} from '@benchling/js-utils';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import NoteStore from 'notebook/bioentities/NoteStore';
import PrintableWrapper from 'notebook/mediocre/print/PrintableWrapper';
import NoteEditorContainer from 'notebook/notes/core-ui/NoteEditorContainer';
import {Note} from 'notebook/util/NoteUtilConstants';

class NotePrintableViewConnector extends DataConnector<Props, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [NoteStore];

  enhanceProps(): EnhancedProps {
    return this.noteStore().getEditorState(this.props.id);
  }
}

interface Props {
  id: string;
  title: string;
}
interface EnhancedProps {
  note?: Note;
}

class NotePrintableView extends React.Component<Props & EnhancedProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  renderEditor = () => {
    if (this.props.note == null) {
      return null;
    }
    return (
      <div>
        <NoteEditorContainer
          fileId={this.props.id}
          note={this.props.note}
          parentType="Note"
          title={this.props.title}
          // Layout for print
          disableFormatting={true}
          hideTitle={false}
          locked={true}
          preview={{showOpenLink: false}}
          viewer={true}
          // Methods (no-op since printable view is non-interactive)
          // @ts-expect-error
          getIdFromCid={noop}
          registerObjects={noop}
          restoreState={() => false}
          storeState={noop}
          undoStoreState={noop}
          undoState={noop}
          redoState={noop}
          // Display Options
          printLayout={false}
          showPrintMargins={false}
          spellCheck={false}
          showTableOfContents={false}
        />
      </div>
    );
  };

  render(): JSX.Element {
    return <PrintableWrapper title={this.props.title}>{this.renderEditor()}</PrintableWrapper>;
  }
}

export default NotePrintableViewConnector.connect(NotePrintableView);
